import { Component, OnInit, Input, Optional, Inject, Output, EventEmitter, HostListener, NgZone, ViewChild, ElementRef } from '@angular/core';
import { ImageViewerConfig, CustomEvent, BlobViewerItem } from './image-viewer-config.model';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { UtilitiesService } from 'src/modules/base/services/utilities.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { AppService } from 'src/modules/base/shared/services/app.service';

const DEFAULT_CONFIG: ImageViewerConfig = {
  btnClass: 'default',
  zoomFactor: 0.1,
  containerBackgroundColor: '#ccc',
  wheelZoom: false,
  allowFullscreen: true,
  allowDownload: true,
  allowKeyboardNavigation: true,
  btnShow: {
    zoomIn: true,
    zoomOut: true,
    rotateClockwise: true,
    rotateCounterClockwise: true,
    next: true,
    prev: true
  },
  btnIcons: {
    zoomIn: 'fa fa-plus',
    zoomOut: 'fa fa-minus',
    rotateClockwise: 'fa fa-repeat',
    rotateCounterClockwise: 'fa fa-undo',
    next: 'fa fa-arrow-right',
    prev: 'fa fa-arrow-left',
    fullscreen: 'fa fa-arrows-alt',
    download: 'fa fa-download',
  }
};

@Component({
    selector: 'app-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.scss'],
    standalone: false
})

export class ImageViewerComponent implements OnInit {

  @Input() src: any;
  @Input() fileData: any;
  @Input() index = 0;
  @Input() config: ImageViewerConfig;
  @Output() indexChange: EventEmitter<number> = new EventEmitter();
  @Output() configChange: EventEmitter<ImageViewerConfig> = new EventEmitter();
  @Output() customEvent: EventEmitter<CustomEvent> = new EventEmitter();

  // ---- NEW: Blob Items Viewer ----
  /** Pass an array of {url, type, name} objects to use the new blob viewer.
   *  When set, the legacy src/fileData viewer is suppressed entirely. */
  @Input() blobItems: BlobViewerItem[] = null;
  public blobIndex = 0;

  get activeBlobItem(): BlobViewerItem | null {
    if (this.blobItems && this.blobItems.length > 0) {
      return this.blobItems[this.blobIndex];
    }
    return null;
  }

  nextBlobItem() {
    if (this.blobItems && this.blobIndex < this.blobItems.length - 1) {
      this.blobIndex++;
      this.reset();
    }
  }

  prevBlobItem() {
    if (this.blobIndex > 0) {
      this.blobIndex--;
      this.reset();
    }
  }
  // ---- END NEW ----

  public style = { transform: '', msTransform: '', oTransform: '', webkitTransform: '' };
  public fullscreen = false;
  public loading = true;
  private scale = 1;
  private rotation = 0;
  private translateX = 0;
  private translateY = 0;
  private prevX: number;
  private prevY: number;
  private hovered = false;
  public data: any = false;
  @ViewChild('imageRef') imageRef: ElementRef;
  serVal: any;
  url: any;
  dataDefined: boolean = false;;

  constructor(@Optional() @Inject('config') public moduleConfig: ImageViewerConfig,public appService: AppService,
    private baseService: BaseService, private ngZone: NgZone, private utilitiesService: UtilitiesService, public dialogConfig: DialogConfig,public rolePermissionService: RolePermissionService) {
      
     }

  ngOnInit() {
    // console.log("jhdsdjdkkdsn ", this.fileData);
    this.serVal = this.utilitiesService.documentMouseOverTarget
        .subscribe(target => this.onMouseOver());
    this.serVal = this.utilitiesService.documentMouseLeaveTarget
        .subscribe(target => this.onMouseLeave());
    this.serVal = this.utilitiesService.documentArrowLeftTarget
        .subscribe(target => this.prevImage(target));
    this.serVal = this.utilitiesService.documentArrowRightTarget
        .subscribe(target => this.nextImage(target));
    if (this.dialogConfig) {
      const merged = this.mergeConfig(DEFAULT_CONFIG, this.moduleConfig);
      this.config = this.mergeConfig(merged, this.config);
      if (this.dialogConfig.data && this.dialogConfig.data.src != undefined) {
        this.src = this.dialogConfig.data.src;
      }
      if (this.dialogConfig.data && this.dialogConfig.data.fileData != undefined) {
        this.fileData = this.dialogConfig.data.fileData;
      }
      // ---- NEW: pick up blobItems from dialog data ----
      if (this.dialogConfig.data && this.dialogConfig.data.blobItems != undefined) {
        this.blobItems = this.dialogConfig.data.blobItems;
      }
      // ---- END NEW ----
      if(this.dialogConfig.data && this.dialogConfig.data.fileData && this.index && (this.dialogConfig.data.fileData[this.index].contentType=='application/pdf' || this.dialogConfig.data.fileData[this.index].contentType=='application/dicom')){
        this.dataDefined = true;
        let resource =  this.dialogConfig.data.resource_name ? this.dialogConfig.data.resource_name: 'emrImage';
        this.url = this.baseService.getApiEndpoint('dms') + resource + '/image-response-entity?args=id:' + this.dialogConfig.data.documentId + '&application=dms';
      }
    }
  }

  ngOnChanges() {
    const merged = this.mergeConfig(DEFAULT_CONFIG, this.moduleConfig);
    this.config = this.mergeConfig(merged, this.config);
    this.triggerConfigBinding();
  }

  //@HostListener('window:keyup.ArrowRight', ['$event'])
  nextImage(event) {
    this.ngZone.runOutsideAngular(() => {
      if (this.canNavigate(event) && this.index < this.src.length - 1) {
        this.loading = true;
        this.index++;
        this.triggerIndexBinding();
        this.reset();
      }
    })
  }

  //@HostListener('window:keyup.ArrowLeft', ['$event'])
  prevImage(event) {
    this.ngZone.runOutsideAngular(() => {
      if (this.canNavigate(event) && this.index > 0) {
        this.loading = true;
        this.index--;
        this.triggerIndexBinding();
        this.reset();
      }
    });
  }

  zoomIn() {
    this.scale *= (1 + this.config.zoomFactor);
    this.updateStyle();
  }

  zoomOut() {
    if (this.scale > this.config.zoomFactor) {
      this.scale /= (1 + this.config.zoomFactor);
    }
    this.updateStyle();
  }

  scrollZoom(evt) {
    if (this.config.wheelZoom) {
      evt.deltaY > 0 ? this.zoomOut() : this.zoomIn();
      return false;
    }
  }

  rotateClockwise() {
    this.rotation += 90;
    this.updateStyle();
  }

  rotateCounterClockwise() {
    this.rotation -= 90;
    this.updateStyle();
  }

  onLoad() {
    this.loading = false;
  }

  onLoadStart() {
    this.loading = true;
  }

  onDragOver(evt) {
    this.translateX += (evt.clientX - this.prevX);
    this.translateY += (evt.clientY - this.prevY);
    this.prevX = evt.clientX;
    this.prevY = evt.clientY;
    this.updateStyle();
  }

  onDragStart(evt) {
    if (evt.dataTransfer && evt.dataTransfer.setDragImage) {
      evt.dataTransfer.setDragImage(evt.target.nextElementSibling, 0, 0);
    }
    this.prevX = evt.clientX;
    this.prevY = evt.clientY;
  }

  toggleFullscreen() {
    this.fullscreen = !this.fullscreen;
    if (!this.fullscreen) {
      this.reset();
    }
  }

  triggerIndexBinding() {
    this.indexChange.emit(this.index);
  }

  triggerConfigBinding() {
    this.configChange.next(this.config);
  }

  fireCustomEvent(name, imageIndex) {
    this.customEvent.emit(new CustomEvent(name, imageIndex));
  }

  reset() {
    this.scale = 1;
    this.rotation = 0;
    this.translateX = 0;
    this.translateY = 0;
    this.updateStyle();
  }


  //@HostListener('mouseover')
  private onMouseOver() {
    this.ngZone.runOutsideAngular(() => {
      this.hovered = true;
    })
  }

  //@HostListener('mouseleave')
  private onMouseLeave() {
    this.ngZone.runOutsideAngular(() => { this.hovered = false; })
  }

  private canNavigate(event: any) {
    return event == null || (this.config.allowKeyboardNavigation && this.hovered);
  }

  private updateStyle() {
    this.style.transform = `translate(${this.translateX}px, ${this.translateY}px) rotate(${this.rotation}deg) scale(${this.scale})`;
    this.style.msTransform = this.style.transform;
    this.style.webkitTransform = this.style.transform;
    this.style.oTransform = this.style.transform;
  }

  private mergeConfig(defaultValues: ImageViewerConfig, overrideValues: ImageViewerConfig): ImageViewerConfig {
    let result: ImageViewerConfig = { ...defaultValues };
    if (overrideValues) {
      result = { ...defaultValues, ...overrideValues };

      if (overrideValues.btnIcons) {
        result.btnIcons = { ...defaultValues.btnIcons, ...overrideValues.btnIcons };
      }
    }
    return result;
  }
  downloadFile(fileData) {
    try {
      if(this.appService.checkNativeApp()){
        var xhr = new XMLHttpRequest();
        xhr.open('GET', this.imageRef.nativeElement.src, true);
        xhr.responseType = 'blob';
        var that = this;
        xhr.onload = function(e) {
          if (this.status == 200) {
            var myBlob = this.response;
            that.baseService.nativeFileHandling(myBlob,myBlob.type,fileData.name);
          }
        };
        xhr.send();
       
      }else{
        var link = document.createElement('a');
        link.target = "_blank";
        link.href = this.imageRef.nativeElement.src;
        link.download = fileData.name;
        link.click();
      }
      
    } catch (e) {
      console.error(e);
    }

  }
}
